import { render, staticRenderFns } from "./AdyenPopup.vue?vue&type=template&id=4a880566&scoped=true&"
import script from "./AdyenPopup.vue?vue&type=script&lang=js&"
export * from "./AdyenPopup.vue?vue&type=script&lang=js&"
import style0 from "./AdyenPopup.vue?vue&type=style&index=0&id=4a880566&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a880566",
  null
  
)

export default component.exports